import { render } from "./ReferralCard.vue?vue&type=template&id=6d391ce8&scoped=true"
import script from "./ReferralCard.vue?vue&type=script&lang=js"
export * from "./ReferralCard.vue?vue&type=script&lang=js"

import "./ReferralCard.vue?vue&type=style&index=0&id=6d391ce8&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d391ce8"]])

export default __exports__